import { createSlice } from "@reduxjs/toolkit";
import {
    fetchInfluencers,
    getInfluencerProfile,
    updateInfluencerProfile,
    uploadProfileImage,
    uploadIntroReel,
    uploadReelThumbnail,
    deleteIntroReel,
    deleteReelThumbnail,
    changeInfluencerPassword
} from "./InfluencerThunk";
import { status } from "../../_constants/common";

const influencerSlice = createSlice({
    name: "influencer",
    initialState: {
        influencers: {
            status: null,
            data: [],
            pagination: null,
        },
        profile: {
            status: null,
            data: null,
        },
        updateProfile: {
            status: null,
        },
        uploadProfileImage: {
            status: null,
        },
        uploadIntroReel: {
            status: null,
        },
        uploadReelThumbnail: {
            status: null,
        },
        deleteIntroReel: {
            status: null,
        },
        deleteReelThumbnail: {
            status: null,
        },
        changePassword: {
            status: null,
        },
    },
    reducers: {
        clearInfluencers: (state) => {
            state.influencers = { status: null, data: [], pagination: null };
        },
        clearProfile: (state) => {
            state.profile = { status: null, data: null };
        },
    },
    extraReducers: (builder) => {
        // Fetch Influencers
        builder
            .addCase(fetchInfluencers.pending, (state) => {
                state.influencers.status = status.IN_PROGRESS;
            })
            .addCase(fetchInfluencers.fulfilled, (state, action) => {
                state.influencers.status = status.SUCCESS;
                state.influencers.data = action.payload?.data || [];
                state.influencers.pagination = action.payload?.pagination || null;
            })
            .addCase(fetchInfluencers.rejected, (state, action) => {
                state.influencers.status = status.FAILURE;
                state.influencers.data = [];
                state.influencers.pagination = null;
            });

        // Get Profile
        builder
            .addCase(getInfluencerProfile.pending, (state) => {
                state.profile.status = status.IN_PROGRESS;
            })
            .addCase(getInfluencerProfile.fulfilled, (state, action) => {
                state.profile.status = status.SUCCESS;
                state.profile.data = action.payload?.data || null;
            })
            .addCase(getInfluencerProfile.rejected, (state, action) => {
                state.profile.status = status.FAILURE;
                state.profile.data = null;
            });

        // Update Profile
        builder
            .addCase(updateInfluencerProfile.pending, (state) => {
                state.updateProfile.status = status.IN_PROGRESS;
            })
            .addCase(updateInfluencerProfile.fulfilled, (state, action) => {
                state.updateProfile.status = status.SUCCESS;
                state.profile.data = action.payload?.data || state.profile.data;
            })
            .addCase(updateInfluencerProfile.rejected, (state, action) => {
                state.updateProfile.status = status.FAILURE;
            });

        // Upload Profile Image
        builder
            .addCase(uploadProfileImage.pending, (state) => {
                state.uploadProfileImage.status = status.IN_PROGRESS;
            })
            .addCase(uploadProfileImage.fulfilled, (state, action) => {
                state.uploadProfileImage.status = status.SUCCESS;
                state.profile.data = action.payload?.data?.profile || state.profile.data;
            })
            .addCase(uploadProfileImage.rejected, (state, action) => {
                state.uploadProfileImage.status = status.FAILURE;
            });

        // Upload Intro Reel
        builder
            .addCase(uploadIntroReel.pending, (state) => {
                state.uploadIntroReel.status = status.IN_PROGRESS;
            })
            .addCase(uploadIntroReel.fulfilled, (state, action) => {
                state.uploadIntroReel.status = status.SUCCESS;
                state.profile.data = action.payload?.data?.profile || state.profile.data;
            })
            .addCase(uploadIntroReel.rejected, (state, action) => {
                state.uploadIntroReel.status = status.FAILURE;
            });

        // Upload Reel Thumbnail
        builder
            .addCase(uploadReelThumbnail.pending, (state) => {
                state.uploadReelThumbnail.status = status.IN_PROGRESS;
            })
            .addCase(uploadReelThumbnail.fulfilled, (state, action) => {
                state.uploadReelThumbnail.status = status.SUCCESS;
                state.profile.data = action.payload?.data?.profile || state.profile.data;
            })
            .addCase(uploadReelThumbnail.rejected, (state, action) => {
                state.uploadReelThumbnail.status = status.FAILURE;
            });

        // Delete Intro Reel
        builder
            .addCase(deleteIntroReel.pending, (state) => {
                state.deleteIntroReel.status = status.IN_PROGRESS;
            })
            .addCase(deleteIntroReel.fulfilled, (state, action) => {
                state.deleteIntroReel.status = status.SUCCESS;
                if (state.profile.data) {
                    state.profile.data.introReel = null;
                }
            })
            .addCase(deleteIntroReel.rejected, (state, action) => {
                state.deleteIntroReel.status = status.FAILURE;
            });

        // Delete Reel Thumbnail
        builder
            .addCase(deleteReelThumbnail.pending, (state) => {
                state.deleteReelThumbnail.status = status.IN_PROGRESS;
            })
            .addCase(deleteReelThumbnail.fulfilled, (state, action) => {
                state.deleteReelThumbnail.status = status.SUCCESS;
                if (state.profile.data) {
                    state.profile.data.reelThumbnail = null;
                }
            })
            .addCase(deleteReelThumbnail.rejected, (state, action) => {
                state.deleteReelThumbnail.status = status.FAILURE;
            });

        // Change Password
        builder
            .addCase(changeInfluencerPassword.pending, (state) => {
                state.changePassword.status = status.IN_PROGRESS;
            })
            .addCase(changeInfluencerPassword.fulfilled, (state, action) => {
                state.changePassword.status = status.SUCCESS;
            })
            .addCase(changeInfluencerPassword.rejected, (state, action) => {
                state.changePassword.status = status.FAILURE;
            });
    },
});

export const { clearInfluencers, clearProfile } = influencerSlice.actions;
export default influencerSlice.reducer;
